const spotlight = {
  default: {
    title: 'Empréstimo para\nvocê conquistar mais',
    description: 'Use seu imóvel, carro ou salário como garantia e tenha a menor taxa do mercado.',
    button: 'Simular agora',
  },
  active: {
    title: 'Oi {{name}}, faltam só mais\nalguns passos',
    description:
      'Sua proposta de empréstimo está em andamento, verifique se há alguma informação pendente que precisa ser preenchida ou enviada. 😊',
  },
  error_message: {
    title: 'Ops! Parece que algo deu errado',
    description: 'Recarregue a página ou tente novamente mais tarde caso o erro persista',
    button: 'Recarregar',
  },
};

export { spotlight };
